import { AfterViewInit, Directive, ViewContainerRef } from '@angular/core';
import { DocumentEditScrollableElementRefService } from './scrollable-element-ref.service';

@Directive({
    selector: '[fiDocumentEditScrollableElementRef]',
    standalone: false,
})
export class DocumentEditScrollableElementRefDirective implements AfterViewInit {
    constructor(
        private scrollableElementRefService: DocumentEditScrollableElementRefService,
        private viewRef: ViewContainerRef,
    ) {}

    ngAfterViewInit() {
        this.scrollableElementRefService.setCurrentViewContainerRef(this.viewRef);
    }
}
